import React from "react";
import { Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";

interface JoinChallengeModalProps {
  onClose: Function;
  shouldShow: boolean;
  joinChallenge: any;
}

interface JoinChallengeModalValues {
  unique_id: string;
}

const JoinChallengeModalSchema = yup.object().shape({
  unique_id: yup.string().required("Unique code is required"),
});

export default function JoinChallengeModal({ onClose, shouldShow, joinChallenge }: JoinChallengeModalProps) {
  const { control, errors, setValue, handleSubmit } = useForm<JoinChallengeModalValues>({
    resolver: yupResolver(JoinChallengeModalSchema),
    defaultValues: {
      unique_id: "",
    },
  });

  const eventApi = useEventApi();
  const toast = useToaster();

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Header>
          <h2 className="modal-header-text">Join Challenge</h2>
          <button type="button" className="btn-close btn-close-white" onClick={() => onClose()}></button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body">
            <h4 className="rider-name-content">Please enter the unique code</h4>
            <div className="mb-3">
              <Controller
                control={control}
                name="unique_id"
                render={({ onChange, onBlur, value, name, ref }) => (
                  <FormTextInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputRef={ref}
                    type="text"
                    error={errors.unique_id}
                    placeholder="Unique Code"
                  />
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={handleSubmit(joinChallenge)}>
              Join
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
